import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import commonService from '../../services/commonService';
import ReviewReportDialog from '../modals/ReviewReportDialog';

const DropDownReviewReportItem = (props) => {
    
    const [reasons, setReasons] = useState("");
    const [dialogIsOpen, setDialogIsOpen] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    
    useEffect(() => {
		commonService.getReviewReportReasons()
                .then((res) => {
                    setReasons(res.data.reasons)
                })
	}, []);

    const handleReviewReport = (revId) => {
        setDialogIsOpen(true);
    }

    const handleDialogClose = () => {
	    setDialogIsOpen(false);
        setConfirmation(false);
	}

    return (
        <>
            <Link 
                to="#"
                onClick={() => handleReviewReport(props.review.id)}
            > 
                <i className="fas fa-flag-alt"></i> Report Review 
            </Link>  
            {reasons && props.review && (
                <ReviewReportDialog 
                    dialogIsOpen={dialogIsOpen} 
                    handleDialogClose={handleDialogClose} 
                    setDialogIsOpen={setDialogIsOpen}
                    reviewId={props.review.id}
                    reasons={reasons}
                    confirmation={confirmation} 
                    setConfirmation={setConfirmation}
                    isOwner={false}
                />
            )}
        </>
    );
};

export default DropDownReviewReportItem;